import React, { useContext, useEffect, useState } from 'react'
import localizaciondata from '../data/localizaciondata.json'

export const LocalizacionCmp = ({addLocalizacion}) => {

    function handlerSeleccion(localizacion) {
       addLocalizacion(localizacion);
    
    }

    return (
        <div>
            <h1 className="text-2xl font-bold mb-10">Dónde desea su sesión?</h1>
            <div className="flex flex-col items-center">
            {localizaciondata.map((item) => (
              
              <button style={{ backgroundColor: 'white', color:'black' }} key={item.localizacion} className="btn m-5 w-1/2" name={item.localizacion} onClick={()=> handlerSeleccion(item)}>
                {item.localizacion}
                </button>
            ))}
          </div>
        </div>
    )
}